<div class='o-wrapper'>
  <div class='o-wrapper__text'>The payment was canceled.</div>
  <button class='o-btn-square-green o-wrapper__btn' (click)='textMessageS.redirect()'>Ok</button>
</div>
